import { render, staticRenderFns } from "./RuleSelector.vue?vue&type=template&id=2664dca3&scoped=true&"
import script from "./RuleSelector.vue?vue&type=script&lang=js&"
export * from "./RuleSelector.vue?vue&type=script&lang=js&"
import style0 from "./RuleSelector.vue?vue&type=style&index=0&id=2664dca3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664dca3",
  null
  
)

export default component.exports